import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useAppContext } from '../../App';
import { auth } from '../../apiService';

export default function MyProfileSection() {
    const { user } = useAppContext();
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChangePassword = async (e) => {
        e.preventDefault();
        if (!currentPassword || !newPassword || !confirmPassword) {
            toast.error("Please fill all password fields.");
            return;
        }
        if (newPassword.length < 8) {
            toast.error("New password must be at least 8 characters.");
            return;
        }
        if (newPassword !== confirmPassword) {
            toast.error("New password confirmation does not match.");
            return;
        }
        setIsSubmitting(true);
        try {
            await auth.changePassword({ email: user.email, currentPassword, newPassword });
            toast.success("Password updated successfully!");
            setCurrentPassword('');
            setNewPassword('');
            setConfirmPassword('');
        } catch (err) {
            toast.error(err.message || "Failed to update password.");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="container mx-auto">
            <div className="mb-8">
                <h1 className="text-4xl font-bold text-gray-800">My Profile</h1>
                <p className="text-gray-500 mt-1">Update your password securely.</p>
            </div>

            <div className="bg-white rounded-2xl shadow-lg p-8 max-w-2xl">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Name</label>
                        <input className="mt-1 w-full p-3 bg-gray-200 rounded-md" value={user?.name || ''} readOnly />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Email</label>
                        <input className="mt-1 w-full p-3 bg-gray-200 rounded-md font-mono" value={user?.email || ''} readOnly />
                    </div>
                </div>

                <form onSubmit={handleChangePassword} className="space-y-6">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Current Password</label>
                        <input type="password" className="mt-1 w-full p-3 bg-gray-50 rounded-md" value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} required />
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                            <label className="block text-sm font-medium text-gray-700">New Password</label>
                            <input type="password" className="mt-1 w-full p-3 bg-gray-50 rounded-md" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required />
                            <p className="text-xs text-gray-500 mt-2">Minimum 8 characters.</p>
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Confirm New Password</label>
                            <input type="password" className="mt-1 w-full p-3 bg-gray-50 rounded-md" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required />
                        </div>
                    </div>

                    <div className="flex justify-end">
                        <button type="submit" disabled={isSubmitting} className="bg-rose-600 text-white font-bold py-3 px-8 rounded-lg shadow-lg hover:bg-rose-700 transition-all disabled:bg-gray-400">
                            {isSubmitting ? 'Updating...' : 'Update Password'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

